module.exports = __webpack_public_path__ + "img/6aa8bc1e626160446e6d660356ca6dd4.e21aa6f9.jpg";